/*
 * TODO - Use this component once the callbacks issue is fixed.
 */
export default {
  name: 'dashify:CardWithEditProps',
  title: 'Card with Edit Props',
  owner: 'System',
  solution: '',
  tags: ['widget', 'card', 'editable', 'props'],
  createdAt: 'Aug 9, 2023, 10:14 AM',
  updatedAt: 'Jan 11, 2024, 7:38 PM',
  spec: {
    props: {
      span: 4,
      cols: '${ span }',
      rows: 1,
      title:
        'Card Title -- unusable at this time because of a callbacks propagation issue when used as part of a dashboard.',
      editableProps: {},
      background: 'brand-bg',
    },
    jsonProps: '${ props.editableProps }',
    onJsonChange: "function($e, $state, $options) { $state ~> | $ | {'jsonProps': $e.value} | }",
    customClassName: '/${ $applyCustomBgColor(props.className, props.background) }',
    view: [
      {
        instanceOf: 'div',
        className:
          '${ "default-text relative rounded overflow-auto px-3 pb-2 col-span-" & props.cols & " " & customClassName  }',
        children: [
          [
            'div',
            { '.': 'flex flex-col h-full' },
            [
              [
                'div',
                { '.': '' },
                [
                  [
                    'div',
                    {
                      '.': 'leading-[15px] font-medium font-sans min-h-[36px] flex items-center',
                    },
                    [
                      ['div', { '.': 'text-xs dark:text-gray-0/[0.937]' }, '${ props.title }'],
                      [
                        'uik:Icon',
                        { '.': 'absolute right-14', type: 'Action.Save' },
                        {
                          onClick: {
                            type: 'updateState',
                            callback: '${ onSaveClick }',
                          },
                        },
                      ],
                      ['uik:Icon', { '.': 'absolute right-4', type: 'Action.Configure' }],
                    ],
                  ],
                ],
              ],
              [
                'div',
                { '.': 'h-[300px]' },
                [
                  [
                    'dashify:JSONEditor',
                    {
                      '.': '',
                      path: 'Name',
                      initialValue: "${ '' & jsonProps }",
                    },
                    null,
                    {
                      onChangeHandler: {
                        type: 'updateState',
                        callback: '${ onJsonChange }',
                      },
                    },
                  ],
                ],
              ],
            ],
          ],
          ['div', { '.': 'grow overflow-auto' }, '${ children }'],
        ],
      },
    ],
  },
};
